import { render, staticRenderFns } from "./Fotos.vue?vue&type=template&id=4c23dc01&"
import script from "./Fotos.vue?vue&type=script&lang=js&"
export * from "./Fotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports